const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Bernoulli — pressure/velocity trade-off in a pipe ──
function DiagramBernoulli() {
  const W = 680, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bernoulli's Equation — Pressure–Velocity Trade-off in a Converging Pipe</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrBR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrBG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrBGr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Pipe walls */}
        <path d="M 44 70 L 240 70 L 340 100 L 636 100"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 44 190 L 240 190 L 340 160 L 636 160"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>

        {/* Fluid fill */}
        <path d="M 44 70 L 240 70 L 340 100 L 636 100 L 636 160 L 340 160 L 240 190 L 44 190 Z"
          fill="#2980b9" opacity="0.10"/>

        {/* Velocity arrows at inlet — slow, short */}
        <line x1="58" y1="108" x2="96"  y2="108" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrB)"/>
        <line x1="58" y1="130" x2="96"  y2="130" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrB)"/>
        <line x1="58" y1="152" x2="96"  y2="152" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrB)"/>

        {/* Velocity arrows at outlet — fast, long */}
        <line x1="530" y1="114" x2="618" y2="114" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrBR)"/>
        <line x1="530" y1="130" x2="618" y2="130" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrBR)"/>
        <line x1="530" y1="146" x2="618" y2="146" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrBR)"/>

        {/* Labels */}
        <text x="72"  y="58"  textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">V₁ (slow)</text>
        <text x="626" y="88"  textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">V₂ (fast)</text>

        {/* Pressure columns (manometer tubes rising from pipe) */}
        {/* High pressure at inlet */}
        <line x1="130" y1="70"  x2="130" y2="40"  stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <rect x="122" y="40" width="16" height="60" rx="3" fill="#2980b9" opacity="0.45"/>
        <line x1="122" y1="40" x2="138" y2="40" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="130" y="30" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">P₁ (high)</text>

        {/* Low pressure at outlet */}
        <line x1="560" y1="100" x2="560" y2="70"  stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <rect x="552" y="92" width="16" height="28" rx="3" fill="#c0392b" opacity="0.45"/>
        <line x1="552" y1="92" x2="568" y2="92" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="560" y="62" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">P₂ (low)</text>

        {/* Section dashed lines */}
        <line x1="44"  y1="62" x2="44"  y2="198" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <line x1="636" y1="92" x2="636" y2="168" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="44"  y="212" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">①</text>
        <text x="636" y="180" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">②</text>

        {/* Bernoulli formula box */}
        <rect x="140" y="218" width="400" height="80" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="340" y="242" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">
          P + ½ρV² + ρgz = constant
        </text>
        <line x1="152" y1="252" x2="528" y2="252" stroke="#f0cece" strokeWidth="1"/>
        <text x="340" y="270" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">
          P₁ + ½ρV₁² + ρgz₁  =  P₂ + ½ρV₂² + ρgz₂
        </text>
        <text x="340" y="288" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888">
          (inviscid, steady, incompressible, along a streamline)
        </text>

        {/* Area labels */}
        <line x1="28" y1="70"  x2="28" y2="190" stroke="#27ae60" strokeWidth="1"
          markerEnd="url(#arrBG)" markerStart="url(#arrBGr)"/>
        <text x="16" y="134" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">A₁</text>
        <line x1="652" y1="100" x2="652" y2="160" stroke="#27ae60" strokeWidth="1"
          markerEnd="url(#arrBG)" markerStart="url(#arrBGr)"/>
        <text x="666" y="134" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">A₂</text>
      </svg>
      <div style={S.dCaption}>
        As the pipe narrows (A₂ &lt; A₁), continuity forces V₂ &gt; V₁. Bernoulli's equation then requires P₂ &lt; P₁ —
        kinetic energy rises at the expense of pressure energy. The total mechanical energy per unit volume remains constant along the streamline.
      </div>
    </div>
  );
}

// ── Diagram 2: Pressure Head Components ──────────────────────────
function DiagramHeads() {
  const W = 680, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydraulic Grade Line (HGL) &amp; Energy Grade Line (EGL)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrHGL" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrEGL" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrVert" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrVertT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Datum */}
        <line x1="40" y1="270" x2="640" y2="270" stroke="#888" strokeWidth="1" strokeDasharray="4 3"/>
        <text x="46" y="284" fontFamily="Georgia,serif" fontSize="11" fill="#888" fontStyle="italic">datum (z = 0)</text>

        {/* Pipe (horizontal then step up then horizontal) */}
        <path d="M 50 240 L 200 240 L 200 200 L 400 200 L 400 220 L 600 220"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 50 252 L 200 252 L 200 212 L 400 212 L 400 232 L 600 232"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        {/* Fluid fill */}
        <path d="M 50 240 L 200 240 L 200 200 L 400 200 L 400 220 L 600 220 L 600 232 L 400 232 L 400 212 L 200 212 L 200 252 L 50 252 Z"
          fill="#2980b9" opacity="0.12"/>

        {/* EGL — total head, stays flat (ideal) */}
        <line x1="50" y1="60" x2="600" y2="60"
          stroke="#c0392b" strokeWidth="2" strokeDasharray="none"/>
        <text x="608" y="64" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#c0392b">EGL</text>
        <text x="608" y="78" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b" fontStyle="italic">(total head)</text>

        {/* HGL — pressure + elevation head */}
        {/* Section 1 (low elevation, wide pipe → slower → higher P) */}
        <line x1="50" y1="110" x2="200" y2="110" stroke="#2980b9" strokeWidth="2"/>
        {/* Section 2 (elevated, narrower → faster → lower P) */}
        <line x1="200" y1="140" x2="400" y2="140" stroke="#2980b9" strokeWidth="2"/>
        {/* Section 3 */}
        <line x1="400" y1="125" x2="600" y2="125" stroke="#2980b9" strokeWidth="2"/>
        {/* connectors */}
        <line x1="200" y1="110" x2="200" y2="140" stroke="#2980b9" strokeWidth="2"/>
        <line x1="400" y1="140" x2="400" y2="125" stroke="#2980b9" strokeWidth="2"/>
        <text x="608" y="128" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">HGL</text>
        <text x="608" y="142" fontFamily="Georgia,serif" fontSize="10" fill="#2980b9" fontStyle="italic">(P/ρg + z)</text>

        {/* Head annotations at section 1 */}
        {/* z₁ */}
        <line x1="92" y1="246" x2="92" y2="270" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="80" y="261" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#555">z₁</text>
        {/* P₁/ρg */}
        <line x1="92" y1="110" x2="92" y2="246" stroke="#2980b9" strokeWidth="1.2"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="80" y="182" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#2980b9">P₁/ρg</text>
        {/* V₁²/2g */}
        <line x1="92" y1="60" x2="92" y2="110" stroke="#c0392b" strokeWidth="1.2"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="80" y="88" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#c0392b">V₁²/2g</text>

        {/* Head annotations at section 2 */}
        {/* z₂ */}
        <line x1="300" y1="206" x2="300" y2="270" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="288" y="242" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#555">z₂</text>
        {/* P₂/ρg */}
        <line x1="300" y1="140" x2="300" y2="206" stroke="#2980b9" strokeWidth="1.2"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="288" y="176" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#2980b9">P₂/ρg</text>
        {/* V₂²/2g */}
        <line x1="300" y1="60" x2="300" y2="140" stroke="#c0392b" strokeWidth="1.2"
          markerEnd="url(#arrVert)" markerStart="url(#arrVertT)"/>
        <text x="288" y="104" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#c0392b">V₂²/2g</text>
      </svg>
      <div style={S.dCaption}>
        The Energy Grade Line (EGL, red) represents total head H = P/ρg + V²/2g + z — constant in ideal flow.
        The Hydraulic Grade Line (HGL, blue) is P/ρg + z. The gap between EGL and HGL is the velocity head V²/2g.
        HGL drops where the pipe rises or narrows (higher velocity → lower pressure head).
      </div>
    </div>
  );
}

// ── Diagram 3: Extended Bernoulli with pump and losses ─────────────
function DiagramExtendedBernoulli() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Extended Bernoulli (Energy Equation) — Pump, Turbine &amp; Head Losses</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrEB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrEBR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrEBG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Pipe system */}
        <path d="M 40 170 L 160 170 L 160 150 L 520 150 L 520 170 L 640 170"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 40 190 L 160 190 L 160 170 L 520 170 L 520 190 L 640 190"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 40 170 L 160 170 L 160 150 L 520 150 L 520 170 L 640 170 L 640 190 L 520 190 L 520 170 L 160 170 L 160 190 L 40 190 Z"
          fill="#2980b9" opacity="0.09"/>

        {/* Flow arrow */}
        <line x1="58" y1="180" x2="100" y2="180" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrEB)"/>
        <line x1="556" y1="180" x2="600" y2="180" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrEB)"/>

        {/* Section markers */}
        <line x1="50"  y1="162" x2="50"  y2="198" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <line x1="630" y1="162" x2="630" y2="198" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="50"  y="210" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#555">①</text>
        <text x="630" y="210" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#555">②</text>

        {/* Pump box */}
        <rect x="185" y="144" width="96" height="32" rx="6"
          fill="#f0fff4" stroke="#27ae60" strokeWidth="1.8"/>
        <text x="233" y="164" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12"
          fontWeight="700" fill="#27ae60">PUMP</text>
        {/* Pump head arrow up */}
        <line x1="233" y1="144" x2="233" y2="110" stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#arrEBG)"/>
        <text x="242" y="126" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">+h_p</text>

        {/* Turbine box */}
        <rect x="355" y="144" width="96" height="32" rx="6"
          fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.8"/>
        <text x="403" y="164" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12"
          fontWeight="700" fill="#c0392b">TURBINE</text>
        {/* Turbine head arrow down */}
        <line x1="403" y1="176" x2="403" y2="210" stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#arrEBR)"/>
        <text x="412" y="200" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">−h_t</text>

        {/* Head loss squiggles between sections */}
        <path d="M 100 130 C 108 122 116 138 124 130 C 132 122 140 138 148 130"
          fill="none" stroke="#888" strokeWidth="1.5"/>
        <path d="M 490 130 C 498 122 506 138 514 130 C 522 122 530 138 538 130"
          fill="none" stroke="#888" strokeWidth="1.5"/>
        <text x="124" y="118" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#888">h_L</text>
        <text x="514" y="118" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#888">h_L</text>

        {/* Formula box */}
        <rect x="80" y="228" width="520" height="58" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="340" y="250" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">
          P₁/ρg + V₁²/2g + z₁ + h_p  =  P₂/ρg + V₂²/2g + z₂ + h_t + h_L
        </text>
        <line x1="92" y1="260" x2="588" y2="260" stroke="#f0cece" strokeWidth="1"/>
        <text x="340" y="276" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">
          h_p = pump head added;   h_t = turbine head extracted;   h_L = total head loss
        </text>
      </svg>
      <div style={S.dCaption}>
        The extended Bernoulli (energy equation) accounts for work added by pumps (+h_p), extracted by turbines (−h_t),
        and lost to friction and minor losses (h_L). In ideal flow with no machines and no losses it reduces to Bernoulli's equation.
      </div>
    </div>
  );
}

// ── Diagram 4: Pitot tube & Pitot-static tube ─────────────────────
function DiagramPitot() {
  const W = 680, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pitot Tube &amp; Pitot-Static Tube — Measuring Flow Velocity</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrPT" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrPTR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrPTV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrPTVT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Flow streamlines */}
        {[70,110,150,190,230].map((y, i) => (
          <g key={y}>
            {/* Upstream portion */}
            <line x1="40" y1={y} x2={i === 2 ? 290 : 450} y2={y}
              stroke="#2980b9" strokeWidth="1.3" opacity="0.50"/>
            {i !== 2 && (
              <line x1="240" y1={y} x2="272" y2={y}
                stroke="#2980b9" strokeWidth="1.3" markerEnd="url(#arrPT)" opacity="0.7"/>
            )}
            {/* Downstream (away from stagnation) */}
            {i !== 2 && (
              <line x1="450" y1={y} x2="640" y2={y}
                stroke="#2980b9" strokeWidth="1.3" opacity="0.50"/>
            )}
          </g>
        ))}

        {/* Pitot tube body */}
        <rect x="290" y="140" width="18" height="120" rx="4"
          fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="1.5"/>
        {/* Stagnation point */}
        <circle cx="299" cy="140" r="5" fill="#c0392b"/>
        <text x="314" y="138" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontWeight="700">stagnation  (V=0)</text>

        {/* Static port holes */}
        <circle cx="299" cy="165" r="3" fill="none" stroke="#27ae60" strokeWidth="1.5"/>
        <circle cx="299" cy="185" r="3" fill="none" stroke="#27ae60" strokeWidth="1.5"/>
        <text x="322" y="180" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60">static ports</text>

        {/* Manometer U-tube */}
        <line x1="308" y1="155" x2="380" y2="155" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <line x1="308" y1="175" x2="380" y2="175" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        {/* U-tube */}
        <rect x="380" y="140" width="14" height="90" rx="3" fill="none" stroke="#888" strokeWidth="1.2"/>
        <rect x="412" y="140" width="14" height="90" rx="3" fill="none" stroke="#888" strokeWidth="1.2"/>
        <path d="M 380 230 Q 380 244 394 244 Q 406 244 412 230"
          fill="none" stroke="#888" strokeWidth="1.2"/>
        {/* Fluid levels */}
        <rect x="382" y="155" width="10" height="75" fill="#c0392b" opacity="0.45" rx="1"/>
        <rect x="414" y="185" width="10" height="45" fill="#c0392b" opacity="0.45" rx="1"/>
        {/* Δh annotation */}
        <line x1="432" y1="155" x2="432" y2="185" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrPTV)" markerStart="url(#arrPTVT)"/>
        <text x="444" y="174" fontFamily="Courier New,monospace" fontSize="11" fill="#333">Δh</text>

        {/* Formula box */}
        <rect x="460" y="100" width="206" height="90" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="563" y="124" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">V = √(2 Δp / ρ)</text>
        <line x1="470" y1="133" x2="656" y2="133" stroke="#f0cece" strokeWidth="1"/>
        <text x="563" y="150" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Δp = P_stag − P_static</text>
        <text x="563" y="167" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">= ½ρV²  (dynamic pressure)</text>
        <text x="563" y="184" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">V = √(2gΔh·ρ_m/ρ_f)</text>

        {/* Velocity label upstream */}
        <text x="130" y="138" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V∞</text>
        <line x1="90" y1="150" x2="160" y2="150" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrPT)"/>
      </svg>
      <div style={S.dCaption}>
        The pitot-static tube measures the difference between stagnation pressure (front hole, V→0) and static pressure (side holes).
        By Bernoulli, this difference equals the dynamic pressure ½ρV², from which flow velocity is recovered: V = √(2Δp/ρ).
        Used on aircraft airspeed indicators, wind tunnels, and industrial flow measurement.
      </div>
    </div>
  );
}

// ── Diagram 5: Venturi Meter ──────────────────────────────────────
function DiagramVenturi() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Venturi Meter — Flow Rate from Pressure Difference</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrVM" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrVMR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrVMV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrVMVT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Venturi shape — converging-throat-diverging */}
        <path d="M 40 80  L 200 80  Q 280 80 300 110 Q 320 140 300 140 Q 280 140 200 140 L 40 140 Z"
          fill="#2980b9" opacity="0.08"/>
        <path d="M 40 80  L 200 80  Q 280 80 300 110"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 40 140 L 200 140 Q 280 140 300 110"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        {/* Diverging section */}
        <path d="M 300 110 Q 360 80 480 80  L 640 80"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 300 110 Q 360 140 480 140 L 640 140"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        {/* Fluid diverging */}
        <path d="M 300 110 Q 360 80 480 80 L 640 80 L 640 140 L 480 140 Q 360 140 300 110 Z"
          fill="#2980b9" opacity="0.08"/>

        {/* Velocity arrows — slow at inlet */}
        <line x1="55"  y1="100" x2="90"  y2="100" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrVM)"/>
        <line x1="55"  y1="120" x2="90"  y2="120" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrVM)"/>
        <text x="100" y="98" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">V₁</text>

        {/* Velocity arrow — fast at throat */}
        <line x1="270" y1="110" x2="330" y2="110" stroke="#c0392b" strokeWidth="3.0" markerEnd="url(#arrVMR)"/>
        <text x="336" y="108" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">V₂ (max)</text>

        {/* Velocity arrows — recovering at outlet */}
        <line x1="550" y1="100" x2="590" y2="100" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrVM)"/>
        <line x1="550" y1="120" x2="590" y2="120" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrVM)"/>

        {/* Pressure tappings (manometer tubes) */}
        {/* At inlet — tall column */}
        <line x1="130" y1="80"  x2="130" y2="40"  stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <rect x="122" y="18" width="16" height="62" rx="3" fill="#2980b9" opacity="0.40"/>
        <line x1="122" y1="18" x2="138" y2="18" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="130" y="12" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#2980b9">P₁</text>

        {/* At throat — short column */}
        <line x1="300" y1="110" x2="300" y2="40"  stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <rect x="292" y="58" width="16" height="22" rx="3" fill="#c0392b" opacity="0.40"/>
        <line x1="292" y1="58" x2="308" y2="58" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="300" y="12" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#c0392b">P₂ (min)</text>

        {/* Connecting U-tube */}
        <line x1="130" y1="32" x2="292" y2="32" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>

        {/* Δh annotation */}
        <line x1="214" y1="18" x2="214" y2="58" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrVMV)" markerStart="url(#arrVMVT)"/>
        <text x="224" y="42" fontFamily="Courier New,monospace" fontSize="11" fill="#333">Δh</text>

        {/* Section labels */}
        <text x="60"  y="158" fontFamily="Georgia,serif" fontSize="11" fill="#555">Section ① (A₁)</text>
        <text x="250" y="158" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontWeight="700">Throat ② (A₂)</text>
        <text x="540" y="158" fontFamily="Georgia,serif" fontSize="11" fill="#555">Recovery ③</text>

        {/* Formula box */}
        <rect x="80" y="175" width="520" height="96" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="340" y="198" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">
          Q = C_d A₂ √( 2(P₁−P₂) / [ρ(1−(A₂/A₁)²)] )
        </text>
        <line x1="92" y1="208" x2="588" y2="208" stroke="#f0cece" strokeWidth="1"/>
        <text x="340" y="226" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">
          C_d = discharge coefficient (0.95–0.99 for well-designed venturi)
        </text>
        <text x="340" y="244" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">
          Typical β = D₂/D₁ = 0.4–0.75;  pressure recovery ~80–90% after throat
        </text>
        <text x="340" y="262" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">
          V₂ = √( 2(P₁−P₂)/ρ · 1/(1−β⁴) )   where β = D₂/D₁
        </text>
      </svg>
      <div style={S.dCaption}>
        The venturi meter uses Bernoulli's equation and continuity to find flow rate from the pressure drop across the converging throat.
        Unlike orifice plates, most of the pressure drop is recovered in the diverging section, giving low permanent pressure loss.
      </div>
    </div>
  );
}

// ── Diagram 6: Torricelli — tank discharge ────────────────────────
function DiagramTorricelli() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torricelli's Theorem — Free Discharge from a Tank Orifice</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrTor" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrTorD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrTorV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrTorVT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Tank walls */}
        <rect x="80" y="40" width="200" height="220" rx="4"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5"/>
        {/* Water in tank */}
        <rect x="82" y="42" width="196" height="152" rx="2" fill="#2980b9" opacity="0.22"/>

        {/* Free surface */}
        <line x1="82" y1="42" x2="278" y2="42" stroke="#2980b9" strokeWidth="1.5" strokeDasharray="5 3"/>
        <text x="86" y="36" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">free surface ①  (V≈0, P=P_atm)</text>

        {/* Orifice */}
        <rect x="278" y="188" width="16" height="20" rx="2" fill="#fff" stroke="#7B0D0D" strokeWidth="1.5"/>
        <text x="300" y="202" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D">orifice ②</text>

        {/* Jet */}
        <path d="M 294 198 Q 360 198 420 220 Q 480 242 540 270"
          fill="none" stroke="#2980b9" strokeWidth="2.2" strokeDasharray="none"/>
        <line x1="418" y1="220" x2="456" y2="234" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrTor)"/>
        <text x="480" y="232" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V = √(2gh)</text>

        {/* Height h annotation */}
        <line x1="56" y1="42"  x2="56" y2="198" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrTorV)" markerStart="url(#arrTorVT)"/>
        <text x="44" y="124" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fill="#333">h</text>

        {/* Datum */}
        <line x1="40" y1="258" x2="560" y2="258" stroke="#888" strokeWidth="1" strokeDasharray="4 3"/>
        <text x="46" y="272" fontFamily="Georgia,serif" fontSize="10" fill="#888" fontStyle="italic">datum</text>

        {/* Streamline from ① to ② */}
        <path d="M 180 42 C 180 120 260 160 278 198"
          fill="none" stroke="#c0392b" strokeWidth="1.3" strokeDasharray="5 3" opacity="0.7"/>
        <line x1="234" y1="170" x2="256" y2="192" stroke="#c0392b" strokeWidth="1.3" markerEnd="url(#arrTorD)" opacity="0.7"/>

        {/* Derivation box */}
        <rect x="310" y="40" width="338" height="140" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="479" y="64" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Apply Bernoulli ① → ②</text>
        <line x1="320" y1="72" x2="638" y2="72" stroke="#f0cece" strokeWidth="1"/>
        <text x="479" y="90" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">P_atm + 0 + ρgh = P_atm + ½ρV² + 0</text>
        <text x="479" y="110" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">∴  V = √(2gh)</text>
        <line x1="320" y1="120" x2="638" y2="120" stroke="#f0cece" strokeWidth="1"/>
        <text x="479" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Q = C_d A_orifice √(2gh)</text>
        <text x="479" y="155" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">C_d ≈ 0.6 for sharp-edged orifice</text>
        <text x="479" y="170" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">(accounts for vena contracta)</text>
      </svg>
      <div style={S.dCaption}>
        Torricelli's theorem: applying Bernoulli between the free surface (V≈0) and the orifice gives the jet velocity V = √(2gh).
        The actual discharge is reduced by the coefficient C_d ≈ 0.6, which accounts for the vena contracta — the further
        contraction of the jet just downstream of the orifice where streamlines are still converging.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function BernoulliAndEnergy() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Bernoulli &amp; Energy Equation</h1>
      <p style={S.p}>
        Bernoulli's equation is the most widely used result in fluid mechanics. It expresses conservation
        of mechanical energy along a streamline in an inviscid, incompressible, steady flow — trading
        pressure energy, kinetic energy, and potential energy among each other. The extended energy equation
        generalises this to real flows with pumps, turbines, and friction losses.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Bernoulli's equation — P + ½ρV² + ρgz = const along a streamline (inviscid, steady, incompressible)",
        "Static, dynamic & stagnation pressure — three pressure components; stagnation = total pressure at V = 0",
        "Hydraulic Grade Line (HGL) and Energy Grade Line (EGL) — graphical representation of head components",
        "Extended Bernoulli — includes pump head h_p, turbine head h_t, and friction loss h_L",
        "Pitot tube — measures stagnation pressure; combined with static port gives V = √(2Δp/ρ)",
        "Venturi meter — uses Bernoulli + continuity to find Q from throat pressure drop",
        "Torricelli's theorem — free-jet velocity from tank orifice: V = √(2gh)",
      ]}/>

      {/* ── Derivation & Assumptions ── */}
      <h2 style={S.h2}>Derivation &amp; Assumptions</h2>
      <p style={S.p}>
        Bernoulli's equation is obtained by integrating Euler's equation of motion along a streamline for
        steady, incompressible, inviscid flow. Every term has units of pressure (Pa) or, when divided by ρg,
        units of length (m) called a head.
      </p>
      <Table2 rows={[
        ["Euler's equation (along streamline)",
`−(1/ρ)(∂P/∂s) − g(∂z/∂s) = V(∂V/∂s)
s = distance along streamline
Integrating (ρ = const, steady): gives Bernoulli's equation`],
        ["Bernoulli's equation — pressure form",
`P + ½ρV² + ρgz = constant  [Pa]
P    = static pressure  [Pa]
½ρV² = dynamic pressure [Pa]
ρgz  = hydrostatic pressure [Pa]`],
        ["Bernoulli's equation — head form",
`P/ρg + V²/2g + z = H  [m]  (total head)
P/ρg   = pressure head [m]
V²/2g  = velocity head [m]
z      = elevation head [m]`],
        ["Key assumptions",
`1. Steady flow (∂/∂t = 0)
2. Incompressible flow (ρ = constant)
3. Inviscid flow (no friction — no viscosity)
4. Applied along a single streamline
5. No heat transfer or work input between points`],
        ["When Bernoulli fails",
`Highly viscous flows (low Re) — viscous losses significant
Turbulent flows — energy dissipated by eddies
Regions of separation or recirculation
Across pump/turbine (work done) — use extended equation
Across shock waves — compressibility and entropy change`],
      ]}/>

      {/* ── Pressure Types ── */}
      <h2 style={S.h2}>Static, Dynamic &amp; Stagnation Pressure</h2>
      <p style={S.p}>
        Bernoulli's equation naturally defines three distinct types of pressure. Understanding the difference
        is essential for interpreting pressure measurements and designing flow instruments.
      </p>
      <Table2 rows={[
        ["Static pressure P",
`Pressure measured by a sensor moving with the fluid (or a wall tapping)
Acts equally in all directions at a point in a static fluid
Measured by holes flush with the pipe wall (perpendicular to flow)`],
        ["Dynamic pressure q",
`q = ½ρV²  [Pa]
Kinetic energy per unit volume; not directly measurable alone
Represents the pressure rise when flow is brought to rest isentropically`],
        ["Stagnation (total) pressure P₀",
`P₀ = P + ½ρV²  (= P_static + P_dynamic)
Pressure when flow is isentropically decelerated to V = 0
Measured by a forward-facing pitot tube
P₀ = const along a streamline in ideal flow`],
        ["Pressure coefficient C_p",
`C_p = (P − P∞) / (½ρV∞²)
Non-dimensional local pressure relative to free-stream dynamic pressure
C_p = 1 at stagnation point;  C_p < 0 where local V > V∞`],
      ]}/>

      {/* ── Bernoulli Diagram ── */}
      <h2 style={S.h2}>Bernoulli in a Converging Pipe</h2>
      <p style={S.p}>
        The most direct illustration of Bernoulli's equation is flow through a converging pipe.
        Continuity forces the velocity to increase in the narrow section; Bernoulli then requires the
        pressure to fall by exactly the same amount of energy per unit volume.
      </p>
      <DiagramBernoulli/>
      <Table2 rows={[
        ["Between two sections (same elevation)",
`P₁ + ½ρV₁² = P₂ + ½ρV₂²
If V₂ > V₁  →  P₂ < P₁
Pressure and velocity are always in opposition`],
        ["Between two sections (different elevation)",
`P₁ + ½ρV₁² + ρgz₁ = P₂ + ½ρV₂² + ρgz₂
Rising flow: kinetic + potential both increase → pressure drops more steeply
Falling flow: potential energy converts to pressure or kinetic`],
        ["Continuity constraint",
`A₁V₁ = A₂V₂  (incompressible)
Combined with Bernoulli: P₁ − P₂ = ½ρV₁²[(A₁/A₂)² − 1]
Pressure drop proportional to V₁² and area ratio squared`],
      ]}/>

      {/* ── HGL & EGL ── */}
      <h2 style={S.h2}>Hydraulic Grade Line &amp; Energy Grade Line</h2>
      <p style={S.p}>
        The HGL and EGL are graphical tools that make head budgets visible. They allow engineers to spot
        where pressure would drop below vapour pressure (cavitation risk) or where the pipe might experience
        negative gauge pressure (siphon action).
      </p>
      <DiagramHeads/>
      <Table2 rows={[
        ["Energy Grade Line (EGL)",
`EGL = P/ρg + V²/2g + z = H  (total head)
Horizontal for ideal flow (no losses)
Drops in the direction of flow when losses exist (friction, bends, fittings)`],
        ["Hydraulic Grade Line (HGL)",
`HGL = P/ρg + z  (piezometric head — pressure + elevation)
EGL − HGL = V²/2g  (velocity head)
HGL < EGL always; gap widens where velocity is high`],
        ["Interpreting the HGL",
`If HGL falls below the pipe centreline: P_gauge < 0 (sub-atmospheric)
If HGL falls below vapour pressure head: cavitation occurs
Siphons operate with HGL below the pipe at the crest`],
        ["Effect of pipe diameter change",
`Wide pipe → slow flow → large V²/2g gap → HGL near EGL
Narrow pipe → fast flow → large gap → HGL far below EGL
At sudden expansion: EGL drops (minor loss); HGL may rise`],
      ]}/>

      {/* ── Extended Bernoulli ── */}
      <h2 style={S.h2}>Extended Bernoulli — Energy Equation</h2>
      <p style={S.p}>
        Real pipe systems include pumps that add energy and turbines that extract it, as well as
        unavoidable friction and minor losses. The extended energy equation accounts for all these terms.
      </p>
      <DiagramExtendedBernoulli/>
      <Table2 rows={[
        ["Extended energy equation",
`P₁/ρg + V₁²/2g + z₁ + h_p = P₂/ρg + V₂²/2g + z₂ + h_t + h_L
h_p = head added by pump [m]
h_t = head extracted by turbine [m]
h_L = total head loss (friction + minor) [m]`],
        ["Pump head h_p",
`h_p = W_pump / (ṁg) = P_pump / (ρgQ)
Pump power:  P = ρgQh_p / η_pump
η_pump = pump efficiency (typically 0.60–0.90)`],
        ["Turbine head h_t",
`h_t = W_turbine / (ṁg)
Turbine power:  P = η_turbine ρgQh_t
η_turbine = turbine efficiency (0.80–0.95 for well-designed units)`],
        ["Major (friction) head loss h_f",
`Darcy-Weisbach: h_f = f (L/D)(V²/2g)
f = Darcy friction factor (from Moody diagram)
Laminar: f = 64/Re;  Turbulent: Colebrook–White equation`],
        ["Minor head losses h_m",
`h_m = K (V²/2g)   K = loss coefficient (geometry-dependent)
Entrance: K ≈ 0.5 (sharp);  Exit: K = 1.0
Bends, valves, fittings: K from tables or manufacturer data`],
      ]}/>

      {/* ── Pitot Tube ── */}
      <h2 style={S.h2}>Pitot Tube &amp; Pitot-Static Tube</h2>
      <p style={S.p}>
        The pitot tube is the simplest direct application of Bernoulli's equation to velocity measurement.
        It brings the flow to rest at a stagnation point and measures the resulting pressure rise.
        Combined with a static pressure tapping, it gives the dynamic pressure and hence velocity.
      </p>
      <DiagramPitot/>
      <Table2 rows={[
        ["Stagnation pressure at tip",
`P_stag = P_static + ½ρV²
At stagnation point: all kinetic energy → pressure energy
P_stag is always the maximum local pressure`],
        ["Velocity from pitot-static",
`V = √(2(P_stag − P_static)/ρ) = √(2Δp/ρ)
If manometer fluid density ρ_m:  V = √(2gΔh · ρ_m/ρ_f)
Aircraft airspeed indicator: calibrated for sea-level ρ`],
        ["Pitot tube applications",
`Aircraft airspeed (IAS — indicated airspeed)
Wind tunnel velocity surveys
River / duct flow profiling (traverse across section)
Industrial gas flow: natural gas pipelines, HVAC ducts`],
        ["Sources of error",
`Misalignment with flow (yaw angle > 5° → significant error)
Turbulence and flow unsteadiness
Viscosity effects at very low Re (Re_D < 100 — Stokes correction needed)
Blockage of static ports by ice — cause of several aircraft incidents`],
      ]}/>

      {/* ── Venturi Meter ── */}
      <h2 style={S.h2}>Venturi Meter &amp; Flow Measurement</h2>
      <p style={S.p}>
        The venturi meter is a precision differential-pressure flow meter. It applies Bernoulli and
        continuity simultaneously: the throat pressure drop reveals the throat velocity, and the known
        throat area gives the volumetric flow rate. It is highly accurate and causes minimal permanent
        pressure loss.
      </p>
      <DiagramVenturi/>
      <Table2 rows={[
        ["Venturi meter equation",
`Q = C_d A₂ √( 2(P₁−P₂) / [ρ(1−(A₂/A₁)²)] )
C_d = 0.95–0.99  (well-machined venturi, Re > 10⁵)
Permanent pressure loss ≈ 10–20% of Δp (low compared to orifice)`],
        ["Orifice plate meter",
`Q = C_d A_orifice √(2Δp / [ρ(1−β⁴)])    β = d/D
C_d ≈ 0.60–0.65  (sharp-edged orifice)
Simple and cheap; permanent loss 50–70% of Δp
Vena contracta: jet contracts to ~60% of orifice area downstream`],
        ["Flow nozzle",
`Intermediate between venturi and orifice
C_d ≈ 0.95–0.98;  permanent loss ~30% of Δp
Better accuracy than orifice; lower cost than venturi`],
        ["Discharge coefficient C_d",
`Accounts for vena contracta (Cc = A_actual/A_theoretical)
and velocity distribution (Cv = V_actual/V_ideal)
C_d = Cc × Cv;  determined by calibration or ISO standards`],
        ["Weirs (open-channel flow)",
`Sharp-crested rectangular weir: Q = (2/3)C_d b √(2g) H^(3/2)
Triangular (V-notch) weir: Q = (8/15)C_d tan(θ/2) √(2g) H^(5/2)
Used for flow measurement in rivers, irrigation canals, and spillways`],
      ]}/>

      {/* ── Torricelli ── */}
      <h2 style={S.h2}>Torricelli's Theorem &amp; Tank Discharge</h2>
      <p style={S.p}>
        Torricelli's theorem — a direct corollary of Bernoulli's equation — gives the velocity of a free
        jet issuing from an orifice in the wall of a large tank. It shows that the jet speed is the same
        as a body in free fall through the same height h.
      </p>
      <DiagramTorricelli/>
      <Table2 rows={[
        ["Torricelli's theorem",
`V_jet = √(2gh)
h = depth of orifice below free surface [m]
Derived by applying Bernoulli ① (surface) → ② (orifice)
Same result as free-fall from height h: v = √(2gh)`],
        ["Actual discharge with C_d",
`Q = C_d A_o √(2gh)
C_d ≈ 0.60 for sharp-edged orifice (vena contracta effect)
C_d ≈ 0.80–0.90 for rounded (bell-mouth) entry
C_d = Cc × Cv  (coefficient of contraction × velocity)`],
        ["Vena contracta",
`Streamlines cannot turn 90° abruptly at a sharp edge
Jet continues to converge after the orifice: minimum area ~0.6 × A_o
Contraction coefficient: Cc = A_vena / A_orifice ≈ 0.611 (sharp edge)`],
        ["Time to drain a tank",
`dh/dt = −(C_d A_o / A_tank) √(2gh)
Integrating: t_drain = (A_tank / C_d A_o) √(2H/g) × (1 − √(h_final/H))
To fully drain (h→0): t = (A_tank / C_d A_o) √(2H/g)`],
        ["Applications",
`Dam spillways and sluice gates
Fire-suppression system flow rates
Inkjet printer orifice design
Tank draining time estimates in chemical plant design`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="BERNOULLI & ENERGY — QUICK REFERENCE" items={[
        "Bernoulli (pressure form):       P + ½ρV² + ρgz = constant  [Pa]",
        "Bernoulli (head form):            P/ρg + V²/2g + z = H  [m]",
        "Stagnation pressure:             P₀ = P_static + ½ρV²",
        "Extended energy equation:        P₁/ρg + V₁²/2g + z₁ + h_p = P₂/ρg + V₂²/2g + z₂ + h_t + h_L",
        "Pitot-static velocity:           V = √(2Δp/ρ) = √(2gΔh · ρ_m/ρ_f)",
        "Venturi / orifice flow rate:     Q = C_d A₂ √(2Δp / [ρ(1−(A₂/A₁)²)])",
        "Darcy-Weisbach head loss:        h_f = f(L/D)(V²/2g);  laminar: f = 64/Re",
        "Minor head loss:                 h_m = K V²/2g;  exit K=1.0, entrance K≈0.5",
        "Torricelli's theorem:            V = √(2gh);  Q = C_d A_o √(2gh)",
        "Tank drain time:                 t = (A_tank / C_d A_o) √(2H/g)",
        "Pump power:                      P = ρgQh_p / η_pump",
        "Turbine power:                   P = η_turbine ρgQh_t",
      ]}/>
    </div>
  );
}